import React              from 'react';
import PropTypes          from 'prop-types';
import Flux               from '../../flux/Flux';
import TileGrid           from './TileGrid';
import assign             from 'object-assign';
import Translations       from '../../utils/Translations';
import HistoryStateHelper from '../../utils/HistoryStateHelper';

class TileGridBox extends React.Component {

	static parseGridConfig(gridConfig, defaultState) {
		defaultState = defaultState || null;

		const state = {};

		if (gridConfig) {
			state.gridConfig = gridConfig;

			if (gridConfig.pagination) {
				state.currentPage = gridConfig.pagination.currentPage;
				state.maxPage     = gridConfig.pagination.maxPage;
			}

			if (gridConfig.sortOptions) {
				state.sortOptions = gridConfig.sortOptions;

				for (let s = 0; s < state.sortOptions.length; s++) {
					if (state.sortOptions[s].selected) {
						state.order   = state.sortOptions[s].order;
						state.sortKey = state.sortOptions[s].sort;

						break;
					}
				}
			}
		}

		let ds;
		if (defaultState) {
			for (ds in defaultState) {
				if (defaultState.hasOwnProperty(ds) && typeof state[ds] === 'undefined') {
					state[ds] = defaultState[ds];
				}
			}
		}
		return state;
	}

	constructor(props) {
		super(props);

		const page  = this.props.useInfiniteScrolling ? 1 : this.props.currentPage;

		const tileGridKey = Flux.TileGrid.getTileGridKeyById(this.props.type);

		const defaultState = {
			gridConfig:  null,
			currentPage: page,
			limit:       this.props.tilesToShow,
		};

		let gridConfig;
		if (tileGridKey && Flux.TileGrid.hasGridData(this.props.type, tileGridKey)) {
			gridConfig = assign({}, Flux.TileGrid.getGridData(this.props.type, tileGridKey));
		} else {
			gridConfig = this.loadGridConfig(this.useCache, page);
		}

		if (gridConfig && typeof gridConfig.totalCount !== 'undefined' && this.props.totalCountHook !== null) {
				this.props.totalCountHook(gridConfig.totalCount);
			}

		const state         = TileGridBox.parseGridConfig(gridConfig, defaultState);
		this.state          = state;
		this.useCache       = false;
		this.isLoadingMore  = false;
		this.requestPayload = {};

		this.onGridChange      = this.onGridChange.bind(this);
		this.onContainerScroll = this.onContainerScroll.bind(this);
		this.loadMore          = this.loadMore.bind(this);
		this.loadGridConfig    = this.loadGridConfig.bind(this);
		this.getPayload        = this.getPayload.bind(this);
		this.onLoadMoreClick   = this.onLoadMoreClick.bind(this);
	}

	componentDidMount() {
		Flux.TileGrid.addGridDataChangeListener(this.onGridChange);

		if (this.props.useInfiniteScrolling) {
			window.addEventListener('scroll', this.onContainerScroll);
		}

		if (this.state.gridConfig && this.state.gridConfig.initialTiles.length > 0 && typeof this.props.onGridRendered === 'function') {
			this.props.onGridRendered();
		}
	}

	componentDidUpdate() {
		this.isLoadingMore = false;

		if (this.state.gridConfig && this.state.gridConfig.initialTiles.length > 0 && typeof this.props.onGridRendered === 'function') {
			this.props.onGridRendered();
		}
	}

	componentWillUnmount() {
		Flux.TileGrid.removeGridDataChangeListener(this.onGridChange);

		if (this.props.useInfiniteScrolling) {
			window.removeEventListener('scroll', this.onContainerScroll);
		}

		if (this.props.tileGridId) {
			Flux.TileGrid.setTileGridKey(this.props.tileGridId, this.getPayload());
		}
	}

	onGridChange(type, error) {
		if (type === this.props.type) {
			this.loading = false;
			if (!error) {
				const page       = this.requestPayload.page ? this.requestPayload.page : null;
				const sort       = this.requestPayload.sort ? this.requestPayload.sort : null;
				const order      = this.requestPayload.order ? this.requestPayload.order : null;
				const gridConfig = this.loadGridConfig(true, page, sort, order);
				const state      = TileGridBox.parseGridConfig(gridConfig, this.props.useInfiniteScrolling ? this.state : null);
				this.setState(state);

				if (typeof gridConfig.totalCount !== 'undefined' && this.props.totalCountHook !== null) {
						this.props.totalCountHook(gridConfig.totalCount);
					}

			} else {
				this.setState({
					gridConfig: {initialTiles: []},
				});
			}
		}
	}

	getPayload(page = null, sort = null, order = null) {
		if (this.state) {
			if (!page && this.state.currentPage) {
				page = this.state.currentPage;
			}

			if (!sort && this.state.sortKey) {
				sort = this.state.sortKey;
			}

			if (!order && this.state.order) {
				order = this.state.order;
			}
		}

		// build payload
		this.payload          = assign({}, this.props.payload, this.payload);
		this.payload['limit'] = this.props.tilesToShow;

		if (page) {
			this.payload['page'] = page;
		}
		if (sort) {
			this.payload['sort'] = sort;
		}
		if (order) {
			this.payload['order'] = order;
		}

		return this.payload;
	}

	loadGridConfig(useCache, page = null, sort = null, order = null) {
		useCache = typeof useCache === 'undefined' || useCache;

		const payload = this.getPayload(page, sort, order);

		let gridConfig = null;
		if (useCache && Flux.TileGrid.hasGridData(this.props.type, payload)) {
			gridConfig = assign({}, Flux.TileGrid.getGridData(this.props.type, payload));
		} else {
			this.requestPayload = payload;
			Flux.TileGrid.loadGrid(this.props.type, payload, true);
		}
		return gridConfig;
	}

	loadMore() {
		const gridConfig = this.loadGridConfig(this.useCache, this.state.currentPage + 1, this.state.sort, this.state.order);
		if (gridConfig) {
			const state = TileGridBox.parseGridConfig(gridConfig, this.props.useInfiniteScrolling ? this.state : undefined);
			this.setState(state);
		}
		HistoryStateHelper.urlReplaceState("page", this.state.currentPage + 1);
	}

	onContainerScroll() {
		const containerBox = document.getElementById(this.props.gridContainerId).getBoundingClientRect();
		if ((containerBox.bottom) < (window.pageYOffset + window.innerHeight + 100) &&
			!this.isLoadingMore &&
			(this.state.currentPage + 1) <= this.state.maxPage &&
			(this.props.scrollTillPageNum === 0 || this.props.scrollTillPageNum > this.state.currentPage)
		) {
			this.isLoadingMore = true;
			this.loadMore();
		}
	}

	onLoadMoreClick(e) {
		this.loadMore();
		if (e.preventDefault) {
			e.preventDefault();
		}
	}

	render() {
		let grid        = null;
		let loadMoreBtn = null;
		if (this.state.gridConfig && this.state.gridConfig.initialTiles.length > 0) {
			grid = <TileGrid gridConfig={this.state.gridConfig}
			                    guestIsLoggedIn={Flux.Guest.isLoggedIn()}
			                    proSearchActiveCategory={this.props.proSearchActiveCategory}
								lazyImageLoading={this.props.lazyImageLoading}
			       />;
			const btnClasses = "js-pjax-link btn -btn-color-transparent-bordered" + (this.props.scrollTillPageNum > this.state.currentPage || this.state.currentPage >= this.state.maxPage ? ' h-disp-none' : '');
			loadMoreBtn      = <a href={HistoryStateHelper.urlSetGetParam(null, "page", this.state.currentPage + 1)} onClick={this.onLoadMoreClick}
			                       className={btnClasses}
			                   >{Translations.get('LoadMore')}
			</a>;
		} else if (this.state.gridConfig && this.state.gridConfig.initialTiles.length === 0) {
			grid = <div className="container-block">
				        <div className="container-block -padding-infotext context-box__subtitle h-text-align-center h-text-light">{this.props.placeHolderText}</div>
				   </div>;
		}

		return <div>
			<div className="h-mb-10">{grid}</div>
			<div className="h-disp-block h-text-align-center">{loadMoreBtn}</div>
		</div>;
	}
}

TileGridBox.propTypes = {
	tileGridId:              PropTypes.string.isRequired,
	payload:                 PropTypes.object,
	proSearchActiveCategory: PropTypes.string,
	tilesToShow:             PropTypes.number,
	type:                    PropTypes.string.isRequired,
	useInfiniteScrolling:    PropTypes.bool,
	gridContainerId:         PropTypes.string.isRequired,
	scrollTillPageNum:       PropTypes.number,
	currentPage:             PropTypes.number,
	placeHolderText:         PropTypes.string,
	totalCountHook:          PropTypes.func,
	onGridRendered:          PropTypes.func,
	lazyImageLoading:        PropTypes.bool,
};

TileGridBox.defaultProps = {
	payload:              {},
	tilesToShow:          12,
	useInfiniteScrolling: false,
	scrollTillPageNum:    0,
	currentPage:          1,
	placeHolderText:      '',
	totalCountHook:       null,
	lazyImageLoading:     false,
	onGridRendered:       () => {},
};

export default TileGridBox;